import './Theme.Wrapper.Stack.scss';
export default 'ThemeWrapperStack';
